import React from "react";
import { Link } from "react-router-dom";
import Drawer from "@material-ui/core/Drawer";
import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import HomeIcon from "@material-ui/icons/Home";
import PeopleIcon from "@material-ui/icons/People";
import BuildIcon from "@material-ui/icons/Build";
import AssignmentIcon from "@material-ui/icons/Assignment";
import AssignmentLateIcon from "@material-ui/icons/AssignmentLate";
import HelpIcon from "@material-ui/icons/Help";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import AccountBoxIcon from "@material-ui/icons/AccountBox";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import MenuIcon from "@material-ui/icons/Menu";
import WorkIcon from "@material-ui/icons/Work";
import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";

class Navigation extends React.Component {
    state = {
        drawerOpened: window.localStorage.getItem("drawerOpened") === "true"
    };
    toggleDrawer = () => {
        const { drawerOpened } = this.state;
        window.localStorage.setItem("drawerOpened", !drawerOpened);
        this.setState({ drawerOpened: !drawerOpened })
    };
    render() {
        const { user: { id, permissions }, path } = this.props;
        const { drawerOpened } = this.state;

        return (
            <Drawer variant="permanent"  classes={{ paper: `app-drawer-paper${drawerOpened ? "" : " app-drawer-paper--closed" }` }} open={drawerOpened} >
                <List>
                    <ListItem button onClick={this.toggleDrawer}>
                        <ListItemIcon>
                            {drawerOpened ? <KeyboardArrowLeftIcon /> : <MenuIcon />}
                        </ListItemIcon>
                        <ListItemText primary="Меню" />
                    </ListItem>
                    <ListItem button component={Link} to="/" >
                        <ListItemIcon classes={{ root: path === "/" ? "nav-li--active" : "nav-li" }} >
                            <HomeIcon />
                        </ListItemIcon>
                        <ListItemText primaryTypographyProps={{ color: path === "/" ? "primary" : "inherit" }} primary="Главная" />
                    </ListItem>
                    <Divider />
                    <ListItem button component={Link} to="/calculator" >
                        <ListItemIcon classes={{ root: path === "/calculator" ? "nav-li--active" : "nav-li" }} >
                            <AttachMoneyIcon />
                        </ListItemIcon>
                        <ListItemText primaryTypographyProps={{ color: path === "/calculator" ? "primary" : "inherit" }} primary="Расчет займа" />
                    </ListItem>
                    <ListItem button component={Link} to="/client/new" >
                        <ListItemIcon classes={{ root: path === "/client/new" ? "nav-li--active" : "nav-li" }} >
                            <PersonAddIcon />
                        </ListItemIcon>
                        <ListItemText primaryTypographyProps={{ color: path === "/client/new" ? "primary" : "inherit" }} primary="Новый клиент" />
                    </ListItem>
                    <Divider />
                    {permissions.includes("clients") &&
                        <ListItem button component={Link} to="/loans" >
                            <ListItemIcon classes={{ root: path === "/loans" ? "nav-li--active" : "nav-li" }} >
                                <PeopleIcon />
                            </ListItemIcon>
                            <ListItemText primaryTypographyProps={{ color: path === "/loans" ? "primary" : "inherit" }} primary="Заявки" />
                        </ListItem>
                    }
                    {permissions.includes("contracts") &&
                        <ListItem button component={Link} to="/contracts/all" >
                            <ListItemIcon classes={{ root: path === "/contracts/all" ? "nav-li--active" : "nav-li" }} >
                                <AssignmentIcon />
                            </ListItemIcon>
                            <ListItemText primaryTypographyProps={{ color: path === "/contracts/all" ? "primary" : "inherit" }} primary="Договоры" />
                        </ListItem>
                    }
                    {permissions.includes("contracts") &&
                        <ListItem button component={Link} to="/contracts/active" >
                            <ListItemIcon classes={{ root: path === "/contracts/active" ? "nav-li--active" : "nav-li" }} >
                                <AssignmentLateIcon />
                            </ListItemIcon>
                            <ListItemText primaryTypographyProps={{ color: path === "/contracts/active" ? "primary" : "inherit" }} primary="Активные" />
                        </ListItem>
                    }
                    <Divider />
                    {permissions.includes("dashboard") &&
                        <ListItem button component={Link} to="/dashboard/users" >
                            <ListItemIcon classes={{ root: path.startsWith("/dashboard") ? "nav-li--active" : "nav-li" }} >
                                <BuildIcon />
                            </ListItemIcon>
                            <ListItemText primaryTypographyProps={{ color: path.startsWith("/dashboard") ? "primary" : "inherit" }} primary="Управление" />
                        </ListItem>
                    }
                    {permissions.includes("bookkeeping") &&
                        <ListItem button component={Link} to="/bookkeeping/transactions" >
                            <ListItemIcon classes={{ root: path.startsWith("/bookkeeping") ? "nav-li--active" : "nav-li" }} >
                                <WorkIcon />
                            </ListItemIcon>
                            <ListItemText primaryTypographyProps={{ color: path.startsWith("/bookkeeping") ? "primary" : "inherit" }} primary="Бухгалтерия" />
                        </ListItem>
                    }
                    <Divider />
                    <ListItem button component={Link} to={`/user/${id}`}>
                        <ListItemIcon classes={{ root: path === `/user/${id}` ? "nav-li--active" : "nav-li" }}>
                            <AccountBoxIcon />
                        </ListItemIcon>
                        <ListItemText primaryTypographyProps={{ color: path === `/user/${id}` ? "primary" : "inherit" }} primary="Профиль" />
                    </ListItem>
                    <ListItem button component={Link} to="/help" >
                        <ListItemIcon classes={{ root: path === "/help" ? "nav-li--active" : "nav-li" }} >
                            <HelpIcon />
                        </ListItemIcon>
                        <ListItemText primaryTypographyProps={{ color: path === "/help" ? "primary" : "inherit" }} primary="Помощь" />
                    </ListItem>
                    <ListItem button component={Link} to="/logout">
                        <ListItemIcon classes={{ root: "nav-li" }}>
                            <ExitToAppIcon />
                        </ListItemIcon>
                        <ListItemText primary="Выход" />
                    </ListItem>
                </List>
            </Drawer>
        );
    }
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/Navigation.js